import React from 'react';

export default function LogoPillIcon() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="14" rx="7" fill="#333536" />
      <path
        d="M10.0002 6.36207C10.7541 5.31893 11.5079 4.27591 12.2618 3.23277C12.3325 3.13506 12.261 3 12.1388 3H11.4597V3.054C11.4815 3.24814 11.445 3.4677 11.3494 3.71228C11.2537 3.957 11.0995 4.22674 10.8866 4.52164C10.5911 4.92886 10.2956 5.33595 10 5.74317C9.70457 5.33595 9.4091 4.92886 9.11349 4.52164C8.90055 4.22674 8.74626 3.957 8.65063 3.71228C8.55525 3.46783 8.51853 3.24827 8.54033 3.054V3H7.86128C7.73904 3 7.66754 3.13506 7.73826 3.23277L10.0002 6.36207Z"
        fill="#C5B4E3"
      />
      <path
        d="M7.56074 3.20791C7.46653 3.07768 7.31354 3.00017 7.15056 3.00017H6.71118V3.05417C6.93139 3.24133 7.13369 3.44627 7.31705 3.66926C7.50092 3.89224 7.73969 4.20163 8.0336 4.59729L9.42012 6.47634L7.738 8.74101C7.40723 9.19423 7.13888 9.54148 6.93346 9.78238C6.72766 10.0234 6.49967 10.2447 6.25 10.446V10.5H6.74933C6.91244 10.5 7.0653 10.4225 7.15951 10.2923L9.92023 6.47253L7.56074 3.20791Z"
        fill="#C5B4E3"
      />
      <path
        d="M13.0667 9.78234C12.8612 9.54143 12.5928 9.19419 12.2621 8.74097L10.58 6.4763L11.9665 4.59724C12.2604 4.20159 12.4992 3.8922 12.6831 3.66921C12.8664 3.44623 13.0687 3.24128 13.289 3.05413V3.00013H12.8496C12.6865 3.00013 12.5336 3.07763 12.4394 3.20787L10.0798 6.47249L12.8405 10.2922C12.9347 10.4225 13.0877 10.5 13.2507 10.5H13.75V10.446C13.5003 10.2447 13.2725 10.0234 13.0667 9.78234Z"
        fill="#C5B4E3"
      />
      <path
        d="M10 6.5829C9.11233 7.81103 8.22474 9.03905 7.33703 10.2672C7.26644 10.3649 7.33781 10.5 7.46005 10.5H8.12366V10.4568C8.10887 10.2555 8.15675 10.018 8.26692 9.7446C8.47713 9.22328 8.79583 8.83817 8.79583 8.83817C8.97335 8.60476 9.15126 8.36729 9.32929 8.12563C9.55936 7.81358 9.78281 7.50406 9.99991 7.19747C10.217 7.50419 10.4406 7.8137 10.6705 8.12563C10.8487 8.36729 11.0266 8.60476 11.204 8.83817C11.204 8.83817 11.5228 9.22328 11.7329 9.7446C11.8432 10.018 11.891 10.2555 11.8762 10.4568V10.5H12.5398C12.662 10.5 12.7334 10.3649 12.6628 10.2672L9.99978 6.5829H10Z"
        fill="#C5B4E3"
      />
    </svg>
  );
}
